module.exports = __webpack_public_path__ + "img/2.e0e16b0a.png";